import { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import "../../css/ListUsers.css";
import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";
import CompanyProductReadOnlyRow from "../../components/CompanyProductReadOnlyRow";
import CompanyProductTableRow from "../../components/CompanyProductTableRow";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import CompanyProductFilter from "./CompanyProductFilter";
import { useTranslation } from 'react-i18next';


function ListCompanyProducts() {
	const navigate = useNavigate();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [errorValue, setErrorValue] = useState("");
	const [keyword, setKeyword] = useState("");
	const [companyId, setCompanyId] = useState(0);
	const [commodityList, setCommodityList] = useState([]);
	const [companyProductList, setCompanyProductList] = useState([]);
	const [count, setCount] = useState(0);
	const { t } = useTranslation();
	const userCtx = useContext(UserContext);

	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		fetchCommodity();
	}, []);

	const initialValues = {
		companyId: 0,
		companyProductKey: 0,
		commodityKey: 0,
		productName: "",
		productSku: "",
		description: "",
		updatedById: userCtx.loggedInUserId,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	const onClickFilterCallback = (searchFilter, selectedCompanyId) => {
		if (searchFilter === keyword && companyId === selectedCompanyId) {
			return
		}
		setKeyword(searchFilter);
		setCompanyId(selectedCompanyId);
		setFormValues({ ...formValues, ["companyId"]: selectedCompanyId });
		fetchCompanyProducts(searchFilter, selectedCompanyId);
	}


	function fetchCommodity() {
		setErrorValue("");
		setIsLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: false }),
		};
		try {
			FetchUtil.fetchAPI("MGetCommodity", "/Service/StaticHelper/GetCommodity", requestOptions, getCommoditySuccess, getCommodityFail);
		} catch (error) {
			setIsLoading(false);
			setErrorValue(error.message);
		}
	}

	function getCommodityFail(redirect) {
		setIsLoading(false);
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.getProdFailed"));
	}
	function getCommoditySuccess(responseData) {
		let getCommodityResponse;
		if (responseData) {
			getCommodityResponse = responseData.getCommodityResponse;
			if (getCommodityResponse && getCommodityResponse.errorCode === "0") {
				setCommodityList([...getCommodityResponse.commodityList]);
			} else if (getCommodityResponse && getCommodityResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getCommodityResponse) {
				setErrorValue(t("error.error") + " " + getCommodityResponse.errorMessage);
			}
		}
		setIsLoading(false);
	}

	function fetchCompanyProducts(searchFilter, selectedCompanyId) {
		setErrorValue("");
		setIsLoading(true);
		resetCounter();
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: true, searchValue: searchFilter, companyId: selectedCompanyId }),
		};
		try {
			FetchUtil.fetchAPI("MGetCompanyProduct", "/Service/CompanyService/GetCompanyProduct", requestOptions, getCompanyProductsSuccess, getCompanyProductsFail);
		} catch (error) {
			setIsLoading(false);
			setErrorValue(error.message);
		}
	}

	function getCompanyProductsFail(redirect) {
		setIsLoading(false);
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.getProdFailed"));
	}
	function getCompanyProductsSuccess(responseData) {
		let getCompanyProductResponse;
		if (responseData) {
			getCompanyProductResponse = responseData.getCompanyProductResponse;
			if (getCompanyProductResponse && getCompanyProductResponse.errorCode === "0") {
				setCompanyProductList([...getCompanyProductResponse.products]);
			} else if (getCompanyProductResponse && getCompanyProductResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getCompanyProductResponse) {
				setErrorValue(t("error.error") + " " + getCompanyProductResponse.errorMessage);
			}
		}
		setIsLoading(false);
	}
	
	const handleDeleteClick = (event, companyProdListItem, completeCallback) => {
		event.preventDefault();
		deleteProduct(companyProdListItem, completeCallback);
	};
	
	const deleteProduct = (companyProdListItem, completeCallback) => {
		let action = 3;
		if (companyProdListItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			companyId: companyId,
			companyProductKey: companyProdListItem.companyProductKey,
			commodityKey: companyProdListItem.commodityKey,
			statusCode: companyProdListItem.statusCode,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteCompanyProduct", "/Service/CompanyService/DeleteCompanyProduct", requestOptions, deleteProductSuccess, deleteProductFail, completeCallback);
		} catch (error) {
			setErrorValue(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteProductFail(redirect, completeCallback) {
		setErrorValue(t("error.prodEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteProductSuccess(responseData, completeCallback) {
		let deleteCompanyProductResponse;
		if (responseData) {
			deleteCompanyProductResponse = responseData.deleteCompanyProductResponse;
			if (deleteCompanyProductResponse) {
				if (deleteCompanyProductResponse.errorCode === "0") {
					resetRowTable();
					fetchCompanyProducts(keyword, companyId);
				} else if (deleteCompanyProductResponse && deleteCompanyProductResponse.errorCode === "114") {
					navigate("/", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				} else {
					setErrorValue(t("error.error") + " " +
						deleteCompanyProductResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setErrorValue("");
		if (!add) {
			setAdd(true);
		} else {
			setErrorValue(t("error.only1RowAllowed"));
		}
	};
	const removeRowTable = () => {
		setErrorValue("");
		resetRowTable();
		setIsLoading(false);
	};

	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setErrorValue("");
		let found = false;
		if (!formValues.companyId) {
			setErrorValue(t("error.companyReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (companyProductList.length > 0) {
				companyProductList.map((companyProdListItem, index) => {
					if (companyProdListItem.commodityKey === setValues.commodityKey
						&& companyProdListItem.productName === setValues.productName
						&& companyProdListItem.productSku === setValues.productSku) {
						setErrorValue(t("error.prodDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveProduct(action, setValues, completeCallback);
			}
		}
	};
	const saveProduct = (action, setValues, completeCallback) => {
		let serverParams = {
			companyId: formValues.companyId,
			commodityKey: setValues.commodityKey,
			productName: setValues.productName,
			productSku: setValues.productSku,
			description: setValues.description,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateCompanyProduct", "/Service/CompanyService/AddUpdateCompanyProduct", requestOptions, saveProductSuccess, saveProductFail, completeCallback);
		} catch (error) {
			setErrorValue(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveProductFail(redirect, completeCallback) {
		setErrorValue(t("error.prodEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveProductSuccess(responseData, completeCallback) {
		let addUpdateCompanyProductResponse;
		if (responseData) {
			addUpdateCompanyProductResponse = responseData.addUpdateCompanyProductResponse;
			if (addUpdateCompanyProductResponse) {
				if (addUpdateCompanyProductResponse.errorCode === "0") {
					resetRowTable();
					fetchCompanyProducts(keyword, companyId);
				} else if (addUpdateCompanyProductResponse.errorCode === "114") {
					navigate("/", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				} else {
					setErrorValue(t("error.error") + " " +
						addUpdateCompanyProductResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	return (
		<div className="container-fluid">
			<Header />
			<div className={"container-fluid container_list viewh-85"}>
				{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
					<>
						<div className="row">
							<div className="col">
								<div
									id="inerrorMessage"
									className={
										(errorValue) ? "errorblock" : "errorblock hide"
									}
								>
									{errorValue ? errorValue : ""}
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<div id="placeholder_1" className="placeholder-pg"></div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<CompanyProductFilter t={t} setErrorValue={setErrorValue} onClickFilterCallback={onClickFilterCallback}
									defaultKeyword={keyword} defaultCompanyId={companyId} setCompanyProductList={setCompanyProductList} />
							</div>
							{(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
						</div>
						<div className="row">
							<div className="col">
								<div id="placeholder_2" className="placeholder-pg"></div>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<table className="list-table" role="table">
									<thead>
										<tr role="row">
											<th className="list-th">{t("page.productGrp")}</th>
											<th className="list-th">{t("page.commoName")}</th>
											<th className="list-th">{t("page.prod")}</th>
											<th className="list-th">{t("page.prodNum")}</th>
											<th className="list-th">{t("page.description")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "9vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</thead>
									<tbody role="rowgroup">
										{add && addRowTop &&
											<CompanyProductTableRow
												index={count}
												commodityList={commodityList}
												handleSubmit={handleSubmit}
												setError={setErrorValue}
												t={t}
												setAdd={setAdd}
												oddIdx={((companyProductList.length % 2) > 0) ? true : false} />
										}
										{companyProductList.length > 0 && (
											companyProductList.map((companyProdListItem, index) => (
												<CompanyProductReadOnlyRow
													index={count}
													t={t}
													companyProdListItem={companyProdListItem}
													handleDeleteClick={handleDeleteClick}
													oddIdx={((index % 2) > 0) ? true : false}
													add={add}
													setError={setErrorValue}
												/>
											))
										)}
										{add && addRowBottom &&
											<CompanyProductTableRow
												index={count}
												commodityList={commodityList}
												handleSubmit={handleSubmit}
												setError={setErrorValue}
												t={t}
												setAdd={setAdd}
												oddIdx={((companyProductList.length % 2) > 0) ? true : false} />
										}
									</tbody>
									{(companyProductList.length > 10) ? (<tfoot>
										<tr role="row">
											<th className="list-th">{t("page.productGrp")}</th>
											<th className="list-th">{t("page.commoName")}</th>
											<th className="list-th">{t("page.prod")}</th>
											<th className="list-th">{t("page.prodNum")}</th>
											<th className="list-th">{t("page.description")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "9vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</tfoot>
									) : (<></>)}
								</table>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div
									id="berrorMessage"
									className={
										(errorValue) ? "errorblock" : "errorblock hide"
									}
								>
									{errorValue ? errorValue : ""}
								</div>
							</div>
						</div>
					</>
					: null}
			</div>
			<div className="footer_container">
				<Footer />
			</div>
		</div>
	);
}

export default ListCompanyProducts;